import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { uniq } from 'lodash';
import { Signature, type WorkOrder } from '@newmoon-org/types';

interface Props {
  workOrder?: WorkOrder;
  showVerbalAsText?: boolean;
  showHeader?: boolean;
}

interface SignatureDTO extends Signature {
  type: 'TA' | 'C';
  formattedDate: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkOrderSignatures',
  props: {
    workOrder: null,
    showVerbalAsText: { type: Boolean },
    showHeader: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { workOrder?: WorkOrder, showVerbalAsText?: boolean, showHeader: boolean }



const showSignatureModal = ref<boolean>(false);
const selectedSignature = ref<Signature | null>(null);

const signatures = computed<SignatureDTO[]>(() => {
  if (!props.workOrder?.itemsSignatureAudit) return [];
  const { itemsSignatureAudit, itemsSignature, completionSignature } = props.workOrder;

  return uniq(
    [
      ...(itemsSignatureAudit ?? []).map(it => ({
        ...it,
        type: 'TA',
        formattedDate: convertToDate(it?.date),
      })),
      {
        ...(itemsSignature ?? {}),
        formattedDate: convertToDate(itemsSignature?.date),
        type: 'TA',
      },
      {
        ...(completionSignature ?? {}),
        formattedDate: convertToDate(completionSignature?.date),
        type: 'C',
      },
    ].filter((it): it is SignatureDTO => !!it.formattedDate)
  );
});

const showEmptyState = computed<boolean>(() => {
  return signatures.value.length === 0;
});

function convertToDate(date: Date | undefined): string {
  if (!date) return '';
  return date.toLocaleString('en-US', {
    timeZone: 'America/Denver',
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

function showSignature(signature: SignatureDTO) {
  selectedSignature.value = signature;
  showSignatureModal.value = true;
}

return { __sfc: true,props, showSignatureModal, selectedSignature, signatures, showEmptyState, convertToDate, showSignature }
}

})